export function Delete({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.75 4.98499C13.2525 4.73749 10.74 4.60999 8.235 4.60999C6.75 4.60999 5.265 4.68499 3.78 4.83499L2.25 4.98499"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.375 4.2275L6.54 3.245C6.66 2.5325 6.75 2 8.0175 2H9.9825C11.25 2 11.3475 2.5625 11.46 3.2525L11.625 4.2275"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1378 7.35498L13.6503 14.9075C13.5678 16.085 13.5003 17 11.4078 17H6.59279C4.50029 17 4.43279 16.085 4.35029 14.9075L3.86279 7.35498"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.74756 12.875H10.2451"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.125 9.875H10.875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
